import React, { createContext, useContext, useState, useCallback } from 'react';

const AppContext = createContext(null);

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within AppProvider');
  }
  return context;
};

export const AppProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [notifications, setNotifications] = useState([]);

  const showError = useCallback((message) => {
    setError(message);
    const notification = {
      id: Date.now(),
      type: 'error',
      message,
    };
    setNotifications((prev) => [...prev, notification]);
    setTimeout(() => {
      setNotifications((prev) => prev.filter((n) => n.id !== notification.id));
    }, 5000);
  }, []);

  const showSuccess = useCallback((message) => {
    const notification = {
      id: Date.now(),
      type: 'success',
      message,
    };
    setNotifications((prev) => [...prev, notification]);
    setTimeout(() => {
      setNotifications((prev) => prev.filter((n) => n.id !== notification.id));
    }, 3000);
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  const setLoadingState = useCallback((isLoading) => {
    setLoading(isLoading);
  }, []);

  const value = {
    loading,
    error,
    notifications,
    setLoading: setLoadingState,
    showError,
    showSuccess,
    clearError,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

